import React from 'react';
import { GridColumns } from '@material-ui/data-grid';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { formatColWithDate } from '@components/datagrid/custom.datagrid.props';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { KicksTable } from '@screens/kicks/kicks.styles';

const columns: GridColumns = [
  { field: 'moderator', headerName: 'Moderator', width: 143 },
  { field: 'actionn', headerName: 'Action', width: 120 },
  { field: 'datee', headerName: 'Date', ...formatColWithDate, width: 170 },
  { field: 'pid', headerName: 'Pid', width: 100 },
  { field: 'fullName', headerName: 'Name', width: 240 },
  { field: 'uid', headerName: 'Uid', width: 163 },
  { field: 'sex', headerName: 'Sex', width: 100 },
  { field: 'groupp', headerName: 'Group', width: 115 },
  { field: 'content', headerName: 'Content', width: 250 },
  { field: 'vip', headerName: 'Vip', width: 97 },
  { field: 'buyer', headerName: 'Buyer', width: 113 },
  { field: 'pix', headerName: 'Pix', width: 97 },
];
interface KicksData {
  pid: number;
  firstName: string;
  lastName: string;
}
let index = 0;
function createData(kicksData: KicksData) {
  index += 1;
  return { id: index, fullName: `${kicksData.firstName} ${kicksData.lastName}`, ...kicksData };
}

interface KicksProps {
  app?: string;
}

const KicksList = (props: KicksProps) => {
  const { authorizedServices } = useAuth();

  async function runSearch(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<KicksData[]>(`/admin/kicks/list/${data.app}`, { params: { page }, cancelToken });
  }

  const { responseData, pageCount, loading, error } = usePagedData(props, runSearch, {
    placeholderData: noopArray,
  });

  const rows = responseData?.map(createData) || [];
  return (
    <KicksTable>
      <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
    </KicksTable>
  );
};

export default KicksList;
